import { render, staticRenderFns } from "./MasterListNoIdentifiers.vue?vue&type=template&id=2c0f598f&scoped=true&"
import script from "./MasterListNoIdentifiers.vue?vue&type=script&lang=js&"
export * from "./MasterListNoIdentifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f598f",
  null
  
)

export default component.exports